const styles = theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 4px 8px 8px',
    borderRadius: '8px',
    gap: '4px',
    transition: 'background-color 0.3s, color 0.3s', // Add transition for smooth animation
    '&:hover': {
      backgroundColor: '#fff',
      cursor: 'pointer',
    },
    '&:hover $selectionDragIcon': {
      color: '#212B36', // Color when the box is hovered
      width: '14px',
    },
    '&:hover $moreFillIcon': {
      color: '#212B36', // Color when the box is hovered
      width: '14px',
      margin: '0 4px',
    },
  },
  selectionDragIcon: {
    width: '0px',
    transition: 'width 0.3s', // Add transition for smooth animation
  },
  moreFillIcon: {
    width: '0px',
  },

  sectionTitleBase: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    maxWidth: '185px',
    lineHeight: '1.2' /* Helps control line height for better readability */,
  },

  sectionTitle: {
    extend: 'sectionTitleBase',
    maxWidth: '185px',
  },

  flexGrowContainer: {
    flexGrow: 1,
  },
})

export default styles
